import { useEffect, useState } from "react";
import { Card, Grid } from "@mui/material";
import Caches from "./components/caches";
import Server from "./components/server";
import Upstreams from "./components/upstreams";
import ServerDomains from "./components/serverDomains";
import MDBox from "../../../../components/MDs/MDBox";
import AppConfig from "../../../../helpers/constants/AppConfig";
import LoadingProgress from "../../../../components/LoadingProgress";

function Statistic({ data }) {
  const [prvData, setPrvData] = useState({
    msec: {
      last: null,
      period: null
    }
  });

  useEffect(() => {
    if (data) {
      prvData["msec"] = {
        last: data.nowMsec,
        period: data.nowMsec - prvData.msec.last
      };
    }
  }, [data]);

  const getReqPerSec = (key, value) => {
    let rps;
    if (prvData[key]) {
      let increase = value - prvData[key];
      rps = Math.floor(increase * 1000 / prvData.msec.period);
    } else {
      rps = "n/a";
    }
    prvData[key] = value;

    return rps;
  }

  const cardStyle = { height: "100%", pt: 2, pb: { md: 4, xs: 2 }, px: 2, boxShadow: 'none' };

  return (
    <>
      {data ?
        <>
          <MDBox
             mt={2.5}
             sx={{ textAlign: 'center' }}
             className="dashboard-stat"
          >
            <Grid item xs={12}>
              <Card sx={cardStyle}>
                <Server data={data} getReqPerSec={getReqPerSec} />
              </Card>
            </Grid>

            {data.serverZones
               ? (
                  <Grid item xs={12}>
                    <Card sx={cardStyle}>
                      <ServerDomains data={data.serverZones} getReqPerSec={getReqPerSec} />
                    </Card>
                  </Grid>
               )
               : null
            }

            {data.upstreamZones
               ? (
                  <Grid item xs={12}>
                    <Card sx={cardStyle}>
                      <Upstreams data={data.upstreamZones} getReqPerSec={getReqPerSec} />
                    </Card>
                  </Grid>
               )
               : null
            }

            {data.cacheZones?.cdn
               ? (
                  <Grid item xs={12}>
                    <Card sx={cardStyle}>
                      <Caches data={data.cacheZones.cdn} getReqPerSec={getReqPerSec} />
                    </Card>
                  </Grid>
               )
               : null
            }
          </MDBox>
        </>
         : (
            <LoadingProgress color={AppConfig.color} />
         )
      }
    </>
  );
}

export default Statistic;
